import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

interface ConfirmationDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

const ConfirmationDeleteModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
}: ConfirmationDeleteModalProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        padding: '16px 16px',
      },
    }}
  >
    <DialogTitle sx={{ textAlign: 'center' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <DeleteIcon sx={{ fontSize: '3rem', color: (theme) => theme.palette.error.main, mb: 1 }} />
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          {title}
        </Typography>
      </div>
    </DialogTitle>
    <DialogContent sx={{ textAlign: 'center' }}>
      <Typography variant="body1">{message}</Typography>
    </DialogContent>
    <DialogActions
      sx={{
        justifyContent: { xs: 'center', sm: 'flex-end' },
        flexDirection: { xs: 'column-reverse', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        gap: 1,
        padding: '0 16px 16px',
        '& > :not(style) ~ :not(style)': {
          marginLeft: 0,
        },
      }}
    >
      <Button onClick={onClose} color="primary" disableElevation>
        {cancelButtonText}
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained" disableElevation>
        {confirmButtonText}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmationDeleteModal;
